import type { FichaInsumosExportPayload } from './exportFichaTecnicaInsumosXlsx'
import { resolvePrecoVigentePorProduto } from './precoVigente'
import {
  gramasEquivalenteUnidadeComercial,
  precoPor100g,
} from './produtoConversaoKg'
import type {
  AlimentoMacronutriente,
  FichaTecnicaItem,
  Preco,
  Produto,
} from '../types/database'

/** Itens da ficha; com pratoId, só os de origem_prato_id igual. */
export function filterFichaItensPorPrato<
  T extends Pick<FichaTecnicaItem, 'ficha_id' | 'origem_prato_id'>,
>(itens: T[], fichaId: string, pratoId: string | null): T[] {
  const daFicha = itens.filter((it) => it.ficha_id === fichaId)
  if (pratoId == null) return daFicha
  return daFicha.filter((it) => it.origem_prato_id === pratoId)
}

type AlimentoRef = Pick<AlimentoMacronutriente, 'id' | 'nome' | 'produto_id'>
type ProdutoRef = Pick<
  Produto,
  | 'id'
  | 'unidade'
  | 'gramas_por_unidade'
  | 'unidades_por_embalagem'
  | 'gramas_por_item'
  | 'ml_por_unidade'
  | 'gramas_por_ml'
>

export function buildFichaInsumosPayload(args: {
  nomePreparacao: string
  modoPreparo: string
  profissional: string
  itens: Pick<FichaTecnicaItem, 'alimento_id' | 'quantidade_g'>[]
  alimentosById: Map<string, AlimentoRef>
  produtosById: Map<string, ProdutoRef>
  precos: Preco[]
  refDate: string
}): FichaInsumosExportPayload {
  const { nomePreparacao, modoPreparo, profissional, itens, alimentosById, produtosById, precos, refDate } =
    args
  return {
    nomePreparacao,
    profissional,
    modoPreparo,
    ingredientes: itens.map((it) => {
      const al = alimentosById.get(it.alimento_id)
      const qtdG = Number(it.quantidade_g) || 0
      const produto = al?.produto_id ? produtosById.get(al.produto_id) : undefined
      const preco = resolvePrecoVigentePorProduto(precos, al?.produto_id, refDate)
      const gramas = produto ? gramasEquivalenteUnidadeComercial(produto) : null
      const unit =
        preco && gramas != null
          ? precoPor100g(Number(preco.valor_unitario) || 0, gramas)
          : null
      const valorUnitario = unit ?? 0
      return {
        item: al?.nome || 'Alimento',
        un: 'G',
        qtdG,
        valorUnitario,
        valorTotal: valorUnitario * (qtdG / 100),
      }
    }),
  }
}
